import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function ReliabilityBanner() {
  return <section className="py-20 text-white relative overflow-hidden" data-id="element-227">
      {/* Background photo */}
      <img src="https://cdn.magicpatterns.com/uploads/m9PBsxg3aQhxLgEALsJtbh/bailey-alexander-2dnjAACDNd8-unsplash.jpg" alt="Sparkling clean modern kitchen" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-228" />
      {/* Brand gradient overlay keeps white text legible over the bright photo */}
      <div className="absolute inset-0 brand-gradient opacity-95 mix-blend-multiply" data-id="element-229" />
      <div className="absolute inset-0 bg-black/25" data-id="element-230" />

      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-64 h-64 bg-white/10 rounded-full blur-3xl" data-id="element-231" />
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-64 h-64 bg-white/10 rounded-full blur-3xl" data-id="element-232" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-233">
        <div className="flex flex-col md:flex-row items-center justify-center text-center md:text-left gap-8 max-w-4xl mx-auto" data-id="element-234">
          <div className="flex-shrink-0 w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-xl" data-id="element-235">
            <ShieldCheck className="w-10 h-10 text-brand-navy" data-id="element-236" />
          </div>

          <div data-id="element-237">
            <h2 className="text-3xl md:text-4xl font-heading font-bold mb-3" data-id="element-238">
              On Time, Every Time. Guaranteed.
            </h2>
            <p className="text-lg md:text-xl text-white/90 font-body" data-id="element-239">
              If we are ever late for a scheduled visit, your next clean is on
              us.
            </p>
          </div>
        </div>
      </div>
    </section>;
}